import './lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { bootstrap } from './lib/bootstrap';
import { reloadOnceForStaleChunk } from './lib/lazyWithReload';
import './index.css';
import './styles/globals.css';

// Stale-chunk reload after deploys: vite:preloadError catches <link rel=modulepreload> 404s;
// the unhandledrejection listener catches direct import() (React.lazy) failures, which bypass it.
// A swallowed vite:preloadError (preventDefault below) makes __vitePreload fulfil with
// `undefined` — lazyWithReload's resolveLazyModule absorbs that without throwing.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadOnceForStaleChunk();
});

window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message ?? String(event.reason ?? '');
  if (/Failed to fetch dynamically imported module|Importing a module script failed/.test(message)) {
    event.preventDefault();
    reloadOnceForStaleChunk();
  }
});
// Syncfusion CSS and license registration are co-located with SyncfusionEditor
// components — they load only when the editor is actually used.

// Initialize the application
const initializeApp = async () => {
  // Bootstrap HTTP client and CSRF protection
  await bootstrap();
  
  // Render the app
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Start the application
initializeApp().catch(console.error);